module.exports = __webpack_public_path__ + "img/shop1.ed0908ea.png";